
const faqBlocks = document.querySelectorAll('.faq-block');

faqBlocks.forEach(block => {
    const title = block.querySelector('.faq-question');
    title.addEventListener('click', function() {
        if(block.classList.contains('active')) {
            block.classList.remove('active');
        } else {
            faqBlocks.forEach(b => b.classList.remove('active'));
            block.classList.add('active');
        }
    });
});